module.exports = __webpack_public_path__ + "static/afp-tou-0a62ffbc103fa6896ee535afbeb2c149.pdf";